import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { SceneStore } from '../stores/SceneStore';
import { SceneActions } from '../actions/SceneActions';
import { GlobalHelper } from '../utils/GlobalHelper';

interface MinMaxButtonProps {
    sidebarOrientation: string;
    layoutType: LayoutType;
}

interface MinMaxButtonState {
    active: boolean;
    activeView: HTMLDivElement | null;
}

export class MinMaxButton extends BaseComponent<MinMaxButtonProps, MinMaxButtonState> {
    public componentWillMount(): void {
        this.addStoreListener(SceneStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (
            !GlobalHelper.coreApp ||
            !GlobalHelper.coreApp.viewer.views.length ||
            GlobalHelper.coreApp.viewer.views.length < 2 ||
            !this.state.activeView
        ) {
            return null;
        }
        const elementBoundingRect: ClientRect = this.state.activeView.getBoundingClientRect();
        const cssStyle: React.CSSProperties = {
            right: 'auto',
            left: elementBoundingRect.left + elementBoundingRect.width - 40,
            top: elementBoundingRect.top > 58 ? elementBoundingRect.top + 2 : elementBoundingRect.top
        };
        return (
            <div
                className={'view-minmaxbutton' + (this.state.active ? ' view-minmaxbutton-active' : '')}
                style={cssStyle}
                onClick={this.toggle}
            />
        );
    }

    protected onChange = () => {
        this.setState({
            active: SceneStore.getState().maximized,
            activeView: SceneStore.getState().activeView
        });
    };

    protected toggle = () => {
        if (this.state.active) {
            SceneActions.MinimizeScene();
        } else {
            SceneActions.MaximizeScene();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MinMaxButton.tsx